import { render, staticRenderFns } from "./HeroSliderBF.vue?vue&type=template&id=61f1816a&scoped=true&"
import script from "./HeroSliderBF.vue?vue&type=script&lang=js&"
export * from "./HeroSliderBF.vue?vue&type=script&lang=js&"
import style0 from "./HeroSliderBF.vue?vue&type=style&index=0&id=61f1816a&prod&scoped=true&lang=css&"
import style1 from "./HeroSliderBF.vue?vue&type=style&index=1&id=61f1816a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f1816a",
  null
  
)

export default component.exports